import React from 'react';
import { Section } from './ui/Section';
export function Benefits() {
  const pillars = [{
    icon: '💃',
    title: 'Técnica',
    desc: 'Sistema probado y documentado'
  }, {
    icon: '🧠',
    title: 'Pedagogía',
    desc: 'Método progresivo que funciona'
  }, {
    icon: '🛡️',
    title: 'Retención',
    desc: 'Protocolos para evitar bajas'
  }, {
    icon: '📈',
    title: 'Negocio',
    desc: 'Gestión y escalabilidad real'
  }];
  return <Section variant="alt" data-id="element-24">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-brand-title mb-4 text-center" data-id="element-25">
        Los 4 Pilares del Sistema
      </h2>
      <p className="text-center text-brand-text mb-8 max-w-2xl mx-auto" data-id="element-26">
        Todo lo que necesitas para dejar de improvisar.
      </p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto" data-id="element-27">
        {pillars.map((pillar, i) => <div key={i} className="bg-white rounded-xl p-6 shadow-card text-center" data-id="element-28">
            <div className="text-4xl mb-3" data-id="element-29">{pillar.icon}</div>
            <h3 className="font-display text-xl font-bold text-brand-title mb-2" data-id="element-30">
              {pillar.title}
            </h3>
            <p className="text-brand-text text-sm" data-id="element-31">{pillar.desc}</p>
          </div>)}
      </div>
    </Section>;
}